import { useState, useEffect, useMemo } from 'react';

/**
 * Hook per countdown basato su timestamp assoluto del server.
 * Immune a clock drift e jitter di rete.
 *
 * @param endsAt - timestamp assoluto (ms) di fine sul server
 * @param serverTime - timestamp (ms) del server al momento dell'invio
 * @returns secondi rimanenti (>= 0)
 */
export function useCountdown(endsAt: number, serverTime: number): number {
  const localEndsAt = useMemo(() => {
    const remainingMs = endsAt - serverTime;
    return Date.now() + remainingMs;
  }, [endsAt, serverTime]);

  const [seconds, setSeconds] = useState(() =>
    Math.max(0, Math.ceil((localEndsAt - Date.now()) / 1000))
  );

  useEffect(() => {
    const tick = () => setSeconds(Math.max(0, Math.ceil((localEndsAt - Date.now()) / 1000)));
    const interval = setInterval(tick, 250);
    return () => clearInterval(interval);
  }, [localEndsAt]);

  return seconds;
}
